var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGnbIco1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 54",
    style: {
      enableBackground: "new 0 0 56 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.66,20.38c-0.51-1.57-1.85-2.7-3.48-2.94L38.14,15.4L31.87,2.69c-0.73-1.48-2.21-2.4-3.87-2.4 c-1.65,0-3.14,0.92-3.87,2.4L17.86,15.4L3.82,17.44c-1.64,0.24-2.97,1.36-3.48,2.94c-0.51,1.57-0.09,3.27,1.09,4.42l10.15,9.9 l-2.4,13.98c-0.28,1.63,0.38,3.25,1.71,4.22c0.74,0.54,1.62,0.83,2.54,0.83c0.7,0,1.39-0.17,2.01-0.5L28,46.62l12.55,6.6 c0.62,0.33,1.31,0.5,2.01,0.5c0.92,0,1.8-0.29,2.54-0.82c1.34-0.97,2-2.59,1.72-4.22l-2.4-13.98l10.16-9.9 C55.75,23.64,56.17,21.95,55.66,20.38z M50.8,23L40.33,33.21l2.47,14.41c0.08,0.48-0.12,0.97-0.51,1.26 c-0.22,0.16-0.49,0.25-0.76,0.25c-0.2,0-0.41-0.05-0.6-0.15L28,42.17l-12.94,6.8c-0.19,0.1-0.39,0.15-0.6,0.15 c-0.27,0-0.53-0.08-0.76-0.25c-0.4-0.29-0.59-0.77-0.51-1.26l2.47-14.41L5.2,23c-0.35-0.34-0.48-0.85-0.33-1.32 c0.15-0.46,0.55-0.8,1.04-0.87l14.47-2.1L26.85,5.6c0.22-0.44,0.66-0.72,1.15-0.72s0.94,0.28,1.15,0.72l6.47,13.11l14.47,2.1 c0.48,0.07,0.89,0.41,1.04,0.87C51.28,22.15,51.15,22.66,50.8,23z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIco1);
export default __webpack_public_path__ + "static/media/gnb_ico1.fac660a1c0daf4d6581b4db416f1ef04.svg";
export { ForwardRef as ReactComponent };